<template>
  <div class="details">

    <div :class="['audit-result', 'audit-result-' + data.status]">
      <img v-if="data.status === '1'" src="/static/image/weatherCertificate/success.png" />
      <img v-if="data.status === '2'" src="/static/image/weatherCertificate/fail.png" />
      {{ data.status | getStatus }}
    </div>

    <div>
      <span class="label">审核意见:</span>
      {{ data.audit_opinion }}
    </div>

    
    <div class="data-image" v-if="data.status === '1'">
      <img :src="data.cert_file" width="100%" height="100%"/>
    </div>
    <van-button v-if="data.status === '1'" round block type="info" @click="download">下载</van-button>
  </div>
</template>

<script>
import Vue from "vue";
import request from '@/utils/request'
import moment from 'moment'
export default Vue.extend({
  components: {
  },
  data() {
    return {
      id: '',
      data: {},


    }
  },
  filters: {
    timeFormat(value) {
      const result = moment(value).format('YYYY-MM-DD HH:mm:ss') // 转换时间格式
      return result
    },
    getStatus(status) {
      let statusLabel = '待审核'

      if (status === '0') {
        statusLabel = '待审核'
      } else if (status === '1') {
        statusLabel = '审核通过'
      } else if (status === '2') {
        statusLabel = '审核未通过'
      }
      return statusLabel
    },
  },
  mounted() {
    this.id = this.$route.params.id
    this.getData()
  },
  methods: {
    getData() {
      request.get(`/wechat_serve/weather_cert/${this.id}`)
        .then((data) => {
          this.data = data
          console.log(data)
        })
    },
    download(){
      window.location.href=this.data.cert_file
    }
  },
})

</script>
<style scoped lang="scss">
.details {
  height: 90vh;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  margin: 20px;
}

.audit-result {
  width: 90vw;
  height: 80px;
  border-radius: 10px;
  display: flex;

  align-items: center;
  justify-content: center;
  text-align: center;

  line-height: 25px;
  font-size: 18px;
  font-weight: 600;
}

.audit-result-1 {
  color: #21CC64;
  background: rgba(33, 204, 100, 0.04);
}
.audit-result-0 {
  color: #b1e52d;
  background: rgba(33, 204, 100, 0.04);
}

.audit-result-2 {
  color: #E95600;
  background: rgba(233, 86, 0, 0.04);
}

.label {
  padding-top: 3px;
  color: #BBBBBB;
}
.data-image {
  display: flex;
  width: 100%;
  height: 100%;
  margin: 20px 0;
  justify-content: center;
}
</style>
